import React from "react";
import GroupIcon from "@mui/icons-material/Group";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ChatIcon from "@mui/icons-material/Chat";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";

const FeaturesSection = () => {
  return (
    <section className="bg-gray-100 py-12">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-blue-900">हमारे प्लैटफ़ॉर्म की विशेषताएं</h2>
      </div>
      <div className="flex flex-wrap justify-center gap-6 px-4 md:px-12">
        {/* Feature 1 */}
        <div className="bg-white shadow-lg rounded-lg p-6 text-center w-full sm:w-[48%] lg:w-[22%]">
          <div className="text-orange-500 mb-4">
            <GroupIcon style={{ fontSize: "3rem" }} />
          </div>
          <h3 className="text-lg font-bold text-blue-900">मातृ पक्ष व पितृ पक्ष वंशावली</h3>
          <p className="text-gray-600 mt-2">
            प्रत्येक समाज बंधु की सुरक्षित व विस्तृत जानकारी।
          </p>
        </div>

        {/* Feature 2 */}
        <div className="bg-white shadow-lg rounded-lg p-6 text-center w-full sm:w-[48%] lg:w-[22%]">
          <div className="text-orange-500 mb-4">
            <VpnKeyIcon style={{ fontSize: "3rem" }} />
          </div>
          <h3 className="text-lg font-bold text-blue-900">केवल समाज के व्यक्ति को ही प्रवेश</h3>
          <p className="text-gray-600 mt-2">
            रिश्ते से रिश्ता जोड़ते हुए ही जोड़ना सम्भव
          </p>
        </div>

        {/* Feature 3 */}
        <div className="bg-white shadow-lg rounded-lg p-6 text-center w-full sm:w-[48%] lg:w-[22%]">
          <div className="text-orange-500 mb-4">
            <ChatIcon style={{ fontSize: "3rem" }} />
          </div>
          <h3 className="text-lg font-bold text-blue-900"> रिश्तेदारी का फ़ेसबुक</h3>
          <p className="text-gray-600 mt-2">
            अपने घर के हर कार्यक्रम की यादें सहेजें और अपनी पूरी रिश्तेदारी में शेयर करें ।
          </p>
        </div>

        {/* Feature 4 */}
        <div className="bg-white shadow-lg rounded-lg p-6 text-center w-full sm:w-[48%] lg:w-[22%]">
          <div className="text-orange-500 mb-4">
            <FavoriteIcon style={{ fontSize: "3rem" }} />
          </div>
          <h3 className="text-lg font-bold text-blue-900">अत्याधुनिक वैवाहिक सेवाओं का प्रबंधन</h3>
          <p className="text-gray-600 mt-2">
            समाज के लिए आधुनिक वैवाहिक सेवाएं प्रदान करना।
          </p>
        </div>

        {/* Feature 5 */}
        <div className="bg-white shadow-lg rounded-lg p-6 text-center w-full sm:w-[48%] lg:w-[22%]">
          <div className="text-orange-500 mb-4">
            <HandshakeOutlinedIcon style={{ fontSize: "3rem" }} />
          </div>
          <h3 className="text-lg font-bold text-blue-900">⁠हर घर करेगा सहयोग</h3>
          <p className="text-gray-600 mt-2">
            हर घर से एक ईंट एक रुपया की तर्ज़ पर समाज के लिए योगदान देना अब इस प्लैट्फ़ॉर्म पर सम्भव होगा।
          </p>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
